import React from "react";
import { Info } from "lucide-react";

const ConsolidationVerifiedBanner: React.FC = () => (
  <div
    id="consolidation-verified-banner"
    className="px-4 sm:px-6 lg:px-8 pb-2 no-print"
  >
    <div className="flex items-start gap-2 px-3 py-2 rounded-md border border-border bg-muted/30 text-sm text-muted-foreground">
      <Info className="size-4 shrink-0 mt-0.5" aria-hidden />
      <span>
        Verificeret visning viser kun godkendte konsolideringer og kan mangle
        ændringer der endnu afventer gennemgang.
      </span>
    </div>
  </div>
);

export default ConsolidationVerifiedBanner;
